var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0006 100.974V150.512C24.0006 177.494 45.8741 199.367 72.8563 199.367C99.8385 199.367 121.712 177.494 121.712 150.512V100.974H24.0006Z",
    fill: "#8541F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M121.706 100.977H24.0002L128.933 16.0007H226.645L121.706 100.977Z",
    fill: "url(#paint0_linear_888_1746)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M275.999 199.026V149.488C275.999 122.506 254.126 100.633 227.144 100.633C200.162 100.633 178.288 122.506 178.288 149.488V199.026H275.999Z",
    fill: "#8541F9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M178.294 199.023H276L171.067 283.999H73.3555L178.294 199.023Z",
    fill: "url(#paint1_linear_888_1746)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_888_1746",
    x1: 125.322,
    y1: 16.0007,
    x2: 125,
    y2: 101.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8541F9",
    stopOpacity: 0.0666667
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8541F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_888_1746",
    x1: 174.678,
    y1: 283.999,
    x2: 175,
    y2: 198.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8541F9",
    stopOpacity: 0.0666667
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8541F9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.bd1a0aea5f6d2423ad806d3bb31a2493.svg";
export { ForwardRef as ReactComponent };